import axios from "axios";
import { handleError } from "../handleError";
import { LError } from "../../object";
const state = {};
const getters = {};
const mutations = {};
const actions = {
  /* 控制器抬杆落杆 */
  async setControllerLock({ dispatch }, params) {
    let { subDeviceId, method, ctrlId } = params;
    let url = `/iotApi/fs/iot/ctrl/instruction?sn=${ctrlId}&method=${method}`;
    let body = {
      subDeviceId,
      ctrlId,
      timestamp: new Date().getTime()
    };
    try {
      let res = await axios.post(url, body);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 查询抬杆落杆结果 */
  async getControllerLockRes({ dispatch }, queryId) {
    let url = "/iotApi/fs/iot/ctrl/record/list";
    let params = {
      searchParam: {
        msgId: {
          operators: [
            {
              keyword: queryId,
              operator: "LIKE"
            }
          ],
          index: 1
        }
      }
    };
    let res = await axios.post(url, params);
    return res;
  },
  /* 查询控制器操作历史 */
  async getControllerOperationHistory(
    { dispatch },
    { pagination, sortStack, search, filter }
  ) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: "/iotApi/fs/iot/ctrl/record/list",
        pagination,
        sortStack,
        search,
        filter: filter || {}
      },
      { root: true }
    );
    return {
      items,
      amount
    };
  },
  /* 获取设备列表 */
  async getDeviceList({ dispatch }, { pagination, sortStack, search, filter }) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: "/iotApi/fs/iot/device/list",
        pagination,
        sortStack,
        search,
        filter: filter || {}
      },
      { root: true }
    );
    return {
      items,
      amount
    };
  },
  /* 获取IOT服务列表 */
  async getServiceList(
    { dispatch },
    { pagination, sortStack, search, filter }
  ) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: "/iotApi/fs/iot/bizsrv/list",
        pagination,
        sortStack,
        search,
        filter: filter || {}
      },
      { root: true }
    );
    return {
      items,
      amount
    };
  },
  async addDevice({ dispatch }, params) {
    let url = "/iotApi/fs/iot/device";
    try {
      let res = await axios.post(url, params);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async addService({ dispatch }, params) {
    let url = "/iotApi/fs/iot/bizsrv";
    try {
      let res = await axios.post(url, params);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async addSubDevice({ dispatch }, params) {
    let url = "/iotApi/fs/iot/device/subdevice";
    try {
      let res = await axios.post(url, params);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async updateService({ dispatch }, params) {
    let url = "/iotApi/fs/iot/bizsrv";
    try {
      let res = await axios.put(url, params);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async updateDevice({ dispatch }, params) {
    let url = "/iotApi/fs/iot/device";
    try {
      let res = await axios.put(url, params);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async deleteService({ dispatch }, params) {
    let url = "/iotApi/fs/iot/bizsrv";
    try {
      let res = await axios.delete(url, { data: params });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async deleteDevice({ dispatch }, params) {
    let url = "/iotApi/fs/iot/device";
    try {
      let res = await axios.delete(url, { data: params });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async deleteSubDevice({ dispatch }, params) {
    let url = "/iotApi/fs/iot/device/subdevice";
    try {
      let res = await axios.delete(url, { data: params });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async getDeviceHearBeatList(
    { dispatch },
    { pagination, sortStack, search, filter }
  ) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: "/iotApi/fs/iot/record/list",
        pagination,
        sortStack,
        search,
        filter: filter || {}
      },
      { root: true }
    );
    return {
      items,
      amount
    };
  },
  async autoGenerateSn({ dispatch }) {
    let url = "/iotApi/fs/iot/sn";
    try {
      let res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async autoGenerateSecret({ dispatch }) {
    let url = "/iotApi/fs/iot/secret";
    try {
      let res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 获取IOT服务列表 */
  async getPackageList(
    { dispatch },
    { pagination, sortStack, search, filter }
  ) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: "/iotApi/fs/iot/device/app/list",
        pagination,
        sortStack,
        search,
        filter: filter || {}
      },
      { root: true }
    );
    return {
      items,
      amount
    };
  },
  async deletePackage({ dispatch }, params) {
    let url = "/iotApi/fs/iot/device/app";
    try {
      let res = await axios.delete(url, { data: params });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 上传文件 */
  async uploadApk({ dispatch }, { formData, version }) {
    let url = "/iotApi/fs/iot/device/app";
    try {
      let res = null;
      res = await axios.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async updateApk({ dispatch }, { formData, version }) {
    let url = "/iotApi/fs/iot/device/app";
    try {
      let res = null;
      res = await axios.put(url, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async sendMessage({ dispatch }, { method, sn }) {
    let url = "/iotApi/fs/iot/ctrl/instruction?sn=" + sn + "&method=" + method;
    try {
      let res = null;
      res = await axios.post(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  async updateController({ dispatch }, { id, sn }) {
    let url =
      "/iotApi/fs/iot/ctrl/instruction?sn=" +
      sn +
      "&method=DEVICESRV_SYS_UPGRADE";
    try {
      let res = null;
      res = await axios.post(url, {
        appId: id
      });
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
